exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-molecules-EditorTimer-___EditorTimer__label___qTJyd {\n  color: #3F4B40;\n  font-size: 14px;\n  font-weight: 300;\n}\n\n  @media screen and (max-width: 480px) {.src-pc-components-molecules-EditorTimer-___EditorTimer__label___qTJyd {\n    display: none\n}\n  }\n", ""]);

// exports
exports.locals = {
	"label": "src-pc-components-molecules-EditorTimer-___EditorTimer__label___qTJyd"
};